export default function MySQL_DATE() {
  return (
    <div>
      <h2>MySQL_DATE</h2>    </div>
  );
}